export enum LocalStorageKeys {
    PARTNER_ID = "partnerID",
}